import SurveyView from './SurveyView';

export default SurveyView;


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/index.js